module.exports = __webpack_public_path__ + "img/weddingwier.6cb51b0b.png";